import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  Divider,
  Box,
  Chip,
  CircularProgress,
} from "@mui/material";
import ActivityRemarks from "../components/ActivitiesItems/ActivityRemarks";
import AppConfig from "../config";
import ClearIcon from "@mui/icons-material/Clear";
import {
  deleteAttachment,
  uploadAttachment,
} from "../services/AttachmentService/AttachmentService";
import AttachmentModal from "./AttachmentModal";

export default function ActivityMenuModal({
  modalOpen,
  handleCloseModal,
  formValues,
  handleChange,
  handleSubmit,
  setFormValues,
  assignee,
  errors,
  setErrors,
  isSubmitDisabled,
  activityHistory,
  projectCode,
  setTagAttachments,
  attachmentCategories,
  statuses,
  remarkCategories,
  selectedSubActivity,
}) {
  const [isFileLoading, setIsFileLoading] = useState(false);
  const [openAttachmentModal, setAttachmentModalOpen] = useState(false);

  const handleChangeWithFile = async (event) => {
    const { name, value, files } = event.target;
    if (files) {
      const filesArray = Array.from(files);
      const formData = new FormData();
      filesArray.forEach((file) => {
        formData.append("file", file);
      });
      try {
        setIsFileLoading(true);
        let iterableUploadFiles = [];
        let tagAttachmentTemp = [];
        const uploadedFiles = await uploadAttachment(formData, projectCode);
        if (uploadedFiles.message == "success") {
          let uploadedObj = {
            name: uploadedFiles.originalName,
            link: uploadedFiles.url,
            uniqueFileName: uploadedFiles.uniqueFileName,
          };

          const tagObject = {
            uniqueFileName: uploadedFiles.uniqueFileName,
          };
          tagAttachmentTemp.push(tagObject);
          setTagAttachments((prev) => [...prev, ...tagAttachmentTemp]);
          iterableUploadFiles.push(uploadedObj);
          setFormValues((prevValues) => ({
            ...prevValues,
            attachments: [
              ...(prevValues.attachments || []),
              ...iterableUploadFiles,
            ],
          }));
        }
      } catch (error) {
        console.error("Error uploading files:", error);
      } finally {
        setIsFileLoading(false);
      }
    } else {
      handleChange(event);
    }
    validateFields(name, value);
  };

  const validateFields = (name, value) => {
    const today = new Date();
    const actualEndDate = new Date(formValues.actualEndDate);
    const startDate = new Date(formValues.startDate);

    if (name === "remarkCategory" || name === "remarkStatement") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: !value || value.trim() === "",
      }));
    }
    if (name === "actualEndDate" && formValues.status === "Done") {
      const isFutureDate = actualEndDate > today;
      const isBeforeStartDate = actualEndDate < startDate;

      setErrors((prevErrors) => ({
        ...prevErrors,
        actualEndDate:
          !value || value.trim() === ""
            ? "Actual End Date is required"
            : isFutureDate
            ? "Actual End Date cannot be in the future"
            : isBeforeStartDate
            ? "Actual End Date cannot be earlier than Start Date"
            : "",
      }));
    }
    if (name === "startDate") {
      const isFutureDate = startDate > today;
      const isAfterEndDate = actualEndDate && startDate > actualEndDate;
      setErrors((prevErrors) => ({
        ...prevErrors,
        startDate:
          !value || value.trim() === ""
            ? "Start Date is required"
            : isFutureDate
            ? "Start Date cannot be in the future"
            : isAfterEndDate
            ? "Start Date cannot be later than Actual End Date"
            : "",
      }));
    }
  };

  const handleFormSubmit = async () => {
    const today = new Date();
    const actualEndDate = new Date(formValues.actualEndDate);
    const startDate = new Date(formValues.startDate);
    if (
      formValues.status === "Done" &&
      (!formValues.actualEndDate ||
        formValues.actualEndDate == "-" ||
        actualEndDate > today ||
        actualEndDate < startDate)
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        actualEndDate:
          !formValues.actualEndDate || formValues.actualEndDate === "-"
            ? "Actual End Date is required"
            : actualEndDate > today
            ? "Actual End Date cannot be in the future"
            : actualEndDate < startDate
            ? "Actual End Date cannot be earlier than Start Date"
            : "",
      }));
      return;
    }
    console.log("Form values ", formValues.attachments);

    if (
      formValues.status === "Done" &&
      selectedSubActivity.attachmentRequired &&
      formValues.attachments.length === 0
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        attachments:
          "Attachment is Required when Updating Activity Status to done",
      }));
      return;
    }
    if (
      formValues.startDate == "-" ||
      !formValues.startDate ||
      startDate > today ||
      startDate > actualEndDate
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        startDate:
          !formValues.startDate || formValues.startDate === "-"
            ? "Start Date is required"
            : startDate > today
            ? "Start Date cannot be in the future"
            : startDate > actualEndDate
            ? "Start Date cannot be later than Actual End Date"
            : "",
      }));
      return;
    }
    console.log("Formvalues attachments ", formValues.attachments);
    handleSubmit();
    setFormValues((prevValues) => ({
      ...prevValues,
      remarkCategory: null,
      remarkStatement: null,
      attachments: [],
    }));
    setErrors({
      remarkCategory: false,
      remarkStatement: false,
      actualEndDate: false,
      startDare: false,
      attachments: false,
    });
    // }
  };
  const handleModalClose = () => {
    handleCloseModal();
    setFormValues((prevValues) => ({
      ...prevValues,

      attachments: [],
      remarkCategory: null,
      remarkStatement: null,
    }));
  };

  const handleRemoveAttachment = async (index) => {
    const attachmentToDelete = formValues.attachments[index];
    try {
      let delResponse = await deleteAttachment(
        attachmentToDelete.uniqueFileName,
        projectCode
      );
      if (delResponse.message == "success") {
        setFormValues((prevValues) => ({
          ...prevValues,
          attachments: prevValues.attachments.filter((_, i) => i !== index),
        }));
        setTagAttachments((prevTagAttachments) =>
          prevTagAttachments.filter((_, i) => i !== index)
        );
      }
    } catch (err) {
      console.log("error in removing attachments");
    }
  };

  const handleAttachmentModalOpen = () => {
    setAttachmentModalOpen(true);
  };

  const handleAttachmentModalClose = () => {
    setAttachmentModalOpen(false);
  };

  return (
    <Dialog maxWidth="lg" open={modalOpen} onClose={handleCloseModal} fullWidth>
      <DialogTitle>{formValues.modalTitle}</DialogTitle>
      <DialogContent>
        {isFileLoading ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"40rem"}
          >
            <CircularProgress />
          </Box>
        ) : (
          <React.Fragment>
            <div>
              <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    size="medium"
                    label={
                      <>
                        Start Date
                        <Typography
                          component="span"
                          sx={{ color: "red", marginLeft: "4px" }}
                        >
                          *
                        </Typography>
                      </>
                    }
                    name="startDate"
                    value={formValues.startDate}
                    onChange={handleChangeWithFile}
                    variant="outlined"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    error={!!errors.startDate}
                    helperText={errors.startDate}
                  />
                  <FormControl fullWidth sx={{ marginTop: "16px" }}>
                    <InputLabel>Assigned To</InputLabel>
                    <Select
                      name="assignedTo"
                      value={formValues.assignedTo}
                      onChange={handleChangeWithFile}
                      label="Assigned To"
                      size="medium"
                      // sx={{
                      //   height: "40px",
                      // }}
                      // MenuProps={{
                      //   PaperProps: {
                      //     style: {
                      //       maxHeight: 290,
                      //     },
                      //   },
                      // }}
                    >
                      {assignee &&
                        assignee?.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.PersonName}>
                              {item.PersonName}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  {/* {formValues?.status == "Done" ? ( */}

                  <TextField
                    fullWidth
                    margin="normal"
                    label="Expected End Date"
                    name="expectedEndDate"
                    value={formValues.expectedEndDate}
                    onChange={handleChangeWithFile}
                    variant="outlined"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    disabled
                  />
                  {/* Status */}

                  <FormControl fullWidth sx={{ marginTop: "16px" }}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      name="status"
                      size="medium"
                      value={formValues.status}
                      onChange={handleChangeWithFile}
                      label="Status"
                    >
                      {statuses?.map((status) => (
                        <MenuItem key={status.id} value={status.status_name}>
                          {status.status_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2} marginBottom={2}>
                <Grid item xs={6}>
                  {/* Remark Category */}
                  <FormControl fullWidth error={errors.remarkCategory}>
                    <InputLabel>
                      Remark Category
                      <Typography
                        component="span"
                        sx={{ color: "red", marginLeft: "4px" }}
                      >
                        *
                      </Typography>
                    </InputLabel>
                    <Select
                      fullWidth
                      name="remarkCategory"
                      value={formValues.remarkCategory}
                      onChange={handleChangeWithFile}
                      label="Remark Category"
                      size="medium"
                      // sx={{
                      //   height: "40px",
                      // }}
                      // MenuProps={{
                      //   PaperProps: {
                      //     style: {
                      //       maxHeight: 290,
                      //     },
                      //   },
                      // }}
                    >
                      {remarkCategories.map((category) => (
                        <MenuItem
                          key={category.id}
                          value={category.remark_category_name}
                        >
                          {category.remark_category_name}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.remarkCategory && (
                      <Typography variant="caption" color="error">
                        Remark Category is required
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  {formValues?.status == "Done" && (
                    <TextField
                      fullWidth
                      // margin="normal"
                      label={
                        <>
                          Actual End Date
                          <Typography
                            component="span"
                            sx={{ color: "red", marginLeft: "4px" }}
                          >
                            *
                          </Typography>
                        </>
                      }
                      name="actualEndDate"
                      value={formValues.actualEndDate}
                      onChange={handleChangeWithFile}
                      variant="outlined"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      disabled={formValues?.status == "Done" ? false : true}
                      error={!!errors.actualEndDate}
                      helperText={errors.actualEndDate}
                    />
                  )}
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label={
                      <>
                        Tender Status
                        <Typography
                          component="span"
                          sx={{ color: "red", marginLeft: "4px" }}
                        >
                          *
                        </Typography>
                      </>
                    }
                    name="tenderStatus"
                    value={formValues.tenderStatus}
                    onChange={handleChangeWithFile}
                    variant="outlined"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    error={!!errors.tenderStatus}
                    helperText={errors.tenderStatus}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={
                    <>
                      Remark Statement
                      <Typography
                        component="span"
                        sx={{ color: "red", marginLeft: "4px" }}
                      >
                        *
                      </Typography>
                    </>
                  }
                  name="remarkStatement"
                  value={formValues.remarkStatement}
                  onChange={handleChangeWithFile}
                  variant="outlined"
                  multiline
                  rows={4}
                  error={errors.remarkStatement}
                  helperText={
                    errors.remarkStatement && "Remark Statement is required"
                  }
                />
              </Grid>
              <Grid item xs={12} marginTop={2}>
                {/* Add Attachment */}
                <Button
                  variant="outlined"
                  sx={{
                    border: "1px solid #b41660",
                    color: "#b41660",
                    "&:hover": {
                      borderColor: "#e91e63",
                      backgroundColor: "rgba(228, 53, 102, 0.1)",
                    },
                  }}
                  onClick={handleAttachmentModalOpen}
                >
                  Add Attachment
                </Button>
                {formValues.attachments.length === 0 && errors.attachments && (
                  <Typography
                    sx={{ display: "block", color: "red", marginTop: "4px" }}
                  >
                    {errors.attachments}
                  </Typography>
                )}
                {/* <input
                  accept="image/jpeg,image/png,application/pdf"
                  type="file"
                  name="attachments"
                  onChange={handleChangeWithFile}
                  style={{ display: "none" }}
                  id="attachment-input"
                />
                <label htmlFor="attachment-input">
                  <Button
                    variant="outlined"
                    sx={{
                      border: "1px solid #b41660",
                      color: "#b41660",
                      "&:hover": {
                        borderColor: "#e91e63",
                        backgroundColor: "rgba(228, 53, 102, 0.1)",
                      },
                    }}
                    component="span"
                  >
                    Upload Attachment
                  </Button>
                </label> */}
              </Grid>
              <Grid item xs={12}>
                {formValues.attachments &&
                  formValues.attachments.length > 0 && (
                    <Box mt={2} display={"flex"} flexWrap={"wrap"}>
                      {formValues.attachments?.map((attachment, index) => (
                        <Box
                          key={index}
                          display={"flex"}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <Chip
                            variant="outlined"
                            sx={{
                              marginRight: "10px",
                              backgroundColor: "#fdeded",
                              color: AppConfig.colorPalette.primary.main,
                              fontWeight: "700",
                              borderRadius: "4px",
                              border: "none",
                              "& .MuiChip-deleteIcon": {
                                backgroundColor: "transparent",
                                fontSize: "1.1rem",
                                "&:hover": {
                                  borderRadius: "50%",
                                  color: AppConfig.colorPalette.primary.main,
                                  fontWeight: "bolder",
                                },
                              },
                            }}
                            label={attachment.name}
                            deleteIcon={<ClearIcon />}
                            // onClick={handleClick}
                            onDelete={() => handleRemoveAttachment(index)}
                          />
                          {/* <DownloadForOfflineIcon
                            sx={{ fontSize: "30px", cursor: "pointer" }}
                          /> */}
                        </Box>
                      ))}
                    </Box>
                  )}
              </Grid>
            </div>
            <Divider sx={{ marginTop: 4, marginBottom: 2 }} />
            <Typography variant="h6">Activity History</Typography>
            <Box sx={{ maxHeight: 200, marginTop: 1 }}>
              {activityHistory.length ? (
                <ActivityRemarks remarksData={activityHistory} />
              ) : (
                ""
              )}
            </Box>
          </React.Fragment>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleModalClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleFormSubmit}
          color="primary"
          disabled={isSubmitDisabled() || isFileLoading}
        >
          Submit
        </Button>
      </DialogActions>
      <AttachmentModal
        open={openAttachmentModal}
        handleClose={handleAttachmentModalClose}
        projectCode={projectCode}
        setTagAttachments={setTagAttachments}
        setFormValues={setFormValues}
        formValues={formValues}
        attachmentCategories={attachmentCategories}
      />
    </Dialog>
  );
}
